import {
  CloseOutlined,
  CloudUploadOutlined,
  DownOutlined,
  EditTwoTone,
  LoadingOutlined,
  SaveOutlined,
} from "@ant-design/icons";
import {
  Spin,
  Row,
  Col,
  Button,
  DatePicker,
  Form,
  Input,
  Image,
  Select,
  Typography,
  message,
  Space,
} from "antd";
import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Utils } from "../../Utilities/Utils";
import { useForm } from "antd/es/form/Form";
import { adminContext } from "../../Common/PageRoute";
import UserService, { roleOption, supportRoleOption } from "../../Services/UserService";
import dayjs from "dayjs";
import { PageHeader } from "../../Common/MainLayout";
//@ts-ignore: Css import issues
import "../../Components/Profile/Profile.css";
import { useUser } from "../../Context/UserContext";
import { Roles } from "../../Services/AuthService";
import { IIdName } from "../../Services/CommonService";

const UserProfile = () => {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [form] = useForm();
  const { isSuperAdmin, isSubAdmin, isSupportAdmin } = useUser();
  const isSupportAdminOnly = isSupportAdmin() && !isSuperAdmin() && !isSubAdmin();
  const { openNotification } = React.useContext(adminContext);
  const [loading, setLoading] = React.useState(false);
  const [isEdit, setIsEdit] = React.useState(true);
  const [imagePath, setImagePath] = React.useState("");
  const [practiceVal, setPracticeVal] = React.useState<{
    label: any;
    value: any;
  }>();
  const [userList, setUserList] = React.useState<IIdName[]>([]);
  const [searchInput, setSearchInput] = React.useState(false);
  const inputRef = React.useRef<any>(null);

  const SetFieldValues = (user: any) => {
    form.setFieldsValue({
      id: user?.id,
      address: user?.address,
      birthDate: user?.birthDate
        ? dayjs(user?.birthDate, "DD/MM/YYYY")
        : undefined,
      email: user?.email,
      fullName: user?.fullName,
      gender: user?.gender ? user?.gender : undefined,
      name: user?.name,
      phoneNumber: user?.phoneNumber,
      role: (() => {
        const rList: string[] = user?.roles ?? (user?.role ? [user.role] : []);
        const found = rList.find((x: string) => {
          const upper = (x || "").toUpperCase();
          return ["SUPERADMIN", "SUPERADMINC", "SUBADMIN", "SUBADMINC", "SUPPORTADMIN", "SUPPORTMANAGER", "SUPPORTUSER"].includes(upper);
        });
        if (!found) return user?.role ? user.role : undefined;
        const upperFound = found.toUpperCase();
        if (upperFound === "SUPERADMIN" || upperFound === "SUPERADMINC") return Roles.SuperAdminC;
        if (upperFound === "SUBADMIN" || upperFound === "SUBADMINC") return Roles.SubAdminC;
        if (upperFound === "SUPPORTADMIN") return Roles.SupportAdminC;
        if (upperFound === "SUPPORTMANAGER") return Roles.SupportManagerC;
        if (upperFound === "SUPPORTUSER") return Roles.SupportUserC;
        return upperFound;
      })(),
      // picture: {
      //   imagePath: user?.picture?.imagePath,
      //   thumbPath: user?.picture?.thumbPath,
      // },
      userName: user?.userName,
    });
  };

  const OnSave = (values: any) => {
    setLoading(true);
    let Values = {
      ...values,
      birthDateStr: dayjs(values?.birthDate).format("DD/MM/YYYY"),
      practiceId: practiceVal?.value,
      userName: values?.email ?? values?.userName,
    };
    let Id = id ?? "";
    UserService.updateUserDetails(Id, Values)
      .then((res) => {
        if (res.status) {
          openNotification("success", "Admin details updated.");
          SetFieldValues(res.result);
        } else openNotification("error", res.message);
      })
      .finally(() => {
        setLoading(false);
        setIsEdit(true);
      });
  };

  React.useEffect(() => {
    if (id !== undefined && id !== null && id !== "") {
      const getUserDetails = async () => {
        setLoading(true);
        await UserService.getUserDetails(id ?? "")
          .then((user: any) => {
            if (user?.status) {
              setImagePath(user?.result?.picture?.imagePath);
              SetFieldValues(user?.result);
              setPracticeVal({
                label: `Practice ${user?.result?.practiceId}`,
                value: user?.result?.practiceId
              });
              // const practiceIds =
              //   user?.result?.practices.map((item: any) => item) || [];
              // setPracticeIds(practiceIds);
            } else {
              openNotification("error", user?.message);
            }
          })
          .finally(() => {
            setLoading(false);
          });
      }
      getUserDetails()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  React.useEffect(() => {
    if (id !== undefined && id !== null && id !== "" && isSuperAdmin()) {
      const getUserDetails = async () => {
        setLoading(true);
        await UserService.getUserOptions()
          .then((user: any) => {
            if (user?.status) {
              setUserList(user?.result?.items || []);
            } else {
              openNotification("error", user?.message);
            }
          })
          .finally(() => {
            setLoading(false);
          });
      }
      getUserDetails()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleUpload = (e: any) => {
    var files: any = e?.currentTarget?.files;
    if (files?.length <= 0) return;
    const formData = new FormData();
    formData.append("file", files[0]);
    UserService.postImage(id, formData).then((result) => {
      if (result.status) {
        openNotification("success", "Profile image updated successfully.");
        setImagePath(result?.result);
      } else {
        openNotification("error", result?.message);
      }
      setLoading(false);
    });
  };

  const selectRef = React.useRef<any>(null);
  React.useEffect(() => {
    if (searchInput && selectRef.current) {
      selectRef.current.focus();
    }
  }, [searchInput]);

  return (
    <>
      <Spin
        spinning={loading}
        indicator={<LoadingOutlined />}
      >
        <Row justify="start" align="middle" style={{ margin: "1px 15px" }}>
          <PageHeader
            item={[
              {
                label: "Admin Users",
                path: isSuperAdmin() ? "/adminusers" : undefined,
              },
              // {
              //   label: form.getFieldValue("fullName") || location?.state?.userName,
              // },
              {
                label:
                  searchInput && isSuperAdmin() ? (
                    <Space>
                      <Select
                        ref={selectRef}
                        size="small"
                        showSearch
                        autoFocus
                        placeholder="Search for year"
                        defaultValue={id}
                        onChange={(id) => {
                          setSearchInput(false);
                          navigate(`/adminuser/profile/${id}`);
                        }}
                        style={{ width: 240 }}
                        options={userList?.map((item: any) => ({
                          label: item.name,
                          value: item.id,
                        }))}
                        filterOption={(input, option) =>
                          (option?.label?.toString() ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                      />
                      <CloseOutlined
                        style={{ paddingRight: 0, color: "#395cd2" }}
                        onClick={() => setSearchInput(false)}
                      />
                    </Space>
                  ) : (
                    <div
                      key="currentYear"
                      style={{
                        paddingRight: 0,
                        display: "flex",
                        justifyContent: "space-between",
                        // color: themeData?.themeData?.themeColor,
                      }}
                      onClick={() => setSearchInput(true)}
                    >
                      <div
                        style={{
                          fontWeight: 600,
                          // fontSize: "13px",
                          // marginTop: "2px",
                        }}
                      >
                        <div>
                          <span style={{ paddingRight: 5 }}>
                            {form.getFieldValue("fullName") || location?.state?.userName}
                          </span>
                          {isSuperAdmin() && <DownOutlined />}
                        </div>
                      </div>
                    </div>
                  )
              }
            ]}
          />
        </Row>
        <Form
          form={form}
          requiredMark={false}
          onFinish={OnSave}
          disabled={isEdit}
          onValuesChange={(changedValues) => {
            if (changedValues?.email) {
              form.setFieldsValue({ userName: changedValues.email });
            }
          }}
        >
          <Row
            className="roundedCornerSmall p-2"
          // style={{ backgroundColor: "white" }}
          >
            <Row
              style={{ width: "100%", minHeight: 750 }}
              justify="space-around"
            >
              <Col span={6} className="bg-white profile-img-col">
                {imagePath !== undefined && imagePath !== "" ? (
                  <>
                    <Image
                      wrapperStyle={{ height: "200px", width: "200px" }}
                      className="rounded profile-img"
                      src={imagePath}
                      alt="Profile image"
                    />
                    <CloudUploadOutlined
                      className="mt-3"
                      style={{ cursor: "pointer" }}
                      onClick={() => inputRef?.current?.click()}
                    />
                    {/* <input
                      type="file"
                      accept=".jpg,.png,.jpeg,.bmp"
                      ref={inputRef}
                      onChange={(e) => {
                        setLoading(true);
                        handleUpload(e);
                      }}
                      style={{ display: "none" }}
                    /> */}
                    <input
                      type="file"
                      accept=".jpg,.png,.jpeg,.bmp"
                      ref={inputRef}
                      onChange={(e) => {
                        const file = e?.currentTarget?.files?.[0];
                        if (file?.type === "image/png" || file?.type === "image/jpeg" || file?.type === "image/jpg") {
                          setLoading(true);
                          handleUpload(e);
                        } else {
                          message.error("Upload only jpeg, jpg & png file");
                        }
                      }}
                      style={{ display: "none" }}
                    />
                  </>
                ) : (
                  <>
                    <CloudUploadOutlined
                      className="mt-3"
                      style={{ cursor: "pointer" }}
                      onClick={() => inputRef?.current?.click()}
                    />
                    <input
                      type="file"
                      accept=".jpg,.png,.jpeg,.bmp"
                      ref={inputRef}
                      onChange={(e) => {
                        const file = e?.currentTarget?.files?.[0];
                        if (file?.type === "image/png" || file?.type === "image/jpeg" || file?.type === "image/jpg") {
                          setLoading(true);
                          handleUpload(e);
                        } else {
                          message.error("Upload only jpeg, jpg & png file");
                        }
                      }}
                      style={{ display: "none" }}
                    />
                  </>
                )}
                <Row justify="center">
                  <Typography.Title
                    level={5}
                    className="mb-2 pt-2"
                    style={{ margin: 0 }}
                  >
                    {form.getFieldValue("fullName")}
                  </Typography.Title>
                </Row>
                <Row justify="center" className="mb-2">
                  {form.getFieldValue("userName")}
                </Row>
              </Col>
              <Col
                span={17}
                className="bg-white detail-col"
                style={{ position: "relative" }}
              >
                <Row
                  className="border-bottom py-2 ps-4 pe-2 font-bold"
                  justify="space-between"
                >
                  Profile information
                  <span
                    className="edit-btn"
                    onClick={() => {
                      setLoading(false);
                      setIsEdit(false);
                    }}
                  >
                    <EditTwoTone />
                  </span>
                </Row>
                <Row className="px-4 pt-3">
                  <Col span={12}>
                    <Form.Item
                      className="custom-form-item"
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 12 }}
                      label="First name"
                      name={["name", "first"]}
                      rules={[
                        { required: true, message: "First name is requried" },
                        { validator: Utils.validateWhiteSpace },
                      ]}
                    >
                      <Input
                        className="line-height-28"
                        placeholder="First name"
                        onKeyPress={(e: any) => Utils.ValidateCharOnly(e)}
                        onInput={(e: any) =>
                        (e.target.value =
                          e.target.value.length > 1
                            ? e.target.value
                            : e.target.value.toUpperCase())
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      className="custom-form-item"
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 12 }}
                      label="Last name"
                      name={["name", "last"]}
                      rules={[
                        { required: true, message: "Last name is requried" },
                        { validator: Utils.validateWhiteSpace },
                      ]}
                    // requiredMark={false}
                    >
                      <Input
                        className="line-height-28"
                        placeholder="Last name"
                        onKeyPress={(e: any) => Utils.ValidateCharOnly(e)}
                        onInput={(e: any) =>
                        (e.target.value =
                          e.target.value.length > 1
                            ? e.target.value
                            : e.target.value.toUpperCase())
                        }
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row className="px-4 pt-1">
                  <Col span={12}>
                    <Form.Item
                      className="custom-form-item"
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 12 }}
                      label="Gender"
                      name="gender"
                    // rules={[
                    //   { required: true, message: "This field is required" },
                    // ]}
                    >
                      <Select
                        className="select-height-28"
                        placeholder="Gender"
                        allowClear
                        options={[
                          // { value: 0, label: "Select" },
                          { value: 1, label: "Male" },
                          { value: 2, label: "Female" },
                        ]}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      className="custom-form-item"
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 12 }}
                      label="Birth date"
                      name="birthDate"
                    // rules={[
                    //   { required: true, message: "This field is required" },
                    //   { validator: Utils.validateBirthdate },
                    // ]}
                    // getValueProps={((i:any)=>({ value: dayjs(i)}))}
                    // getValueFromEvent={(onChange) => dayjs(onChange).format("DD/MM/YYYY")}
                    >
                      <DatePicker
                        style={{ width: "100%", height: 28 }}
                        className="line-height-28"
                        placeholder="Birth date"
                        format="DD/MM/YYYY"
                      //defaultValue={dayjs(userProfile?.birthDate, "DD/MM/YYYY")}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row className="px-4 pt-1">
                  <Col span={12}>
                    <Form.Item
                      className="custom-form-item"
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 12 }}
                      label="Email"
                      name="email"
                      rules={[
                        { required: true, message: "This field is required" },
                        { validator: Utils.ValidateEmailFormat },
                      ]}
                    >
                      <Input
                        disabled={isEdit || !isSuperAdmin()}
                        className="line-height-28"
                        placeholder="Email"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      className="custom-form-item"
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 12 }}
                      label="Phone number"
                      name="phoneNumber"
                    // rules={[
                    //   { required: true, message: "This field is required" },
                    //   {
                    //     pattern: /^[0-9]{10}$/,
                    //     message: "Mobile No. must be 10 digits",
                    //   },
                    // ]}
                    >
                      <Input
                        className="line-height-28"
                        placeholder="Phone number"
                        onKeyPress={(e) => Utils.ValidateNumberOnly(e)}
                        maxLength={10}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row className="px-4 pt-1">
                  {(isSuperAdmin() || isSupportAdmin()) &&
                    <Col span={12}>
                      <Form.Item
                        className="custom-form-item"
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 12 }}
                        label="Role"
                        name="role"
                        rules={[
                          { required: true, message: "This field is required" },
                        ]}
                      >
                        <Select
                          className="select-height-28"
                          placeholder="Role"
                          options={isSupportAdminOnly ? supportRoleOption : roleOption}
                        />
                      </Form.Item>
                    </Col>
                  }
                  {/* <Col span={12}>
                    <Form.Item
                      className="custom-form-item"
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 12 }}
                      label="Practice"
                      rules={[
                        { required: true, message: "Practice id is required" },
                      ]}
                    >
                      <Select
                        className="select-height-28"
                        disabled={isEdit}
                        placeholder="Practice"
                        options={practiceOptions}
                        value={practiceVal}
                        onChange={(val) => {
                          setPracticeVal({label:`Practice ${val}`,value: val});
                        }}
                      />
                    </Form.Item>
                  </Col> */}
                </Row>
                {/* <Row className="font-bold ps-4 py-3">Address information</Row>
                <Row className="px-4 ">
                  <Col span={12}>
                    <Form.Item
                      className="custom-form-item"
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 12 }}
                      label="Building"
                      name={["address", "building"]}
                    >
                      <Input
                        disabled={isEdit}
                        className="line-height-28"
                        placeholder="Building"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      className="custom-form-item"
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 12 }}
                      label="Street"
                      name={["address", "street"]}
                    >
                      <Input
                        disabled={isEdit}
                        className="line-height-28"
                        placeholder="Street"
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row className="px-4 pt-1">
                  <Col span={12}>
                    <Form.Item
                      className="custom-form-item"
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 12 }}
                      label="City"
                      name={["address", "city"]}
                    >
                      <Input
                        disabled={isEdit}
                        className="line-height-28"
                        placeholder="City"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      className="custom-form-item"
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 12 }}
                      label="County"
                      name={["address", "county"]}
                    >
                      <Input
                        disabled={isEdit}
                        className="line-height-28"
                        placeholder="County"
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row className="px-4 pt-1">
                  <Col span={12}>
                    <Form.Item
                      className="custom-form-item"
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 12 }}
                      label="Country"
                      name={["address", "country"]}
                    >
                      <Select
                        showSearch
                        disabled={isEdit}
                        className="line-height-28"
                        placeholder="Country"
                        options={countriesOptions}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      className="custom-form-item"
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 12 }}
                      label="Post code"
                      name={["address", "postcode"]}
                    >
                      <Input
                        disabled={isEdit}
                        className="line-height-28"
                        placeholder="Post Code"
                      />
                    </Form.Item>
                  </Col>
                </Row> */}
                {!isEdit && (
                  <Row
                    className="pe-5 pb-4 mb-0"
                    style={{ position: "absolute", bottom: 0, right: 0 }}
                    justify={"end"}
                  >
                    <Button
                      className=""
                      onClick={() => {
                        setIsEdit(true);
                        //   SetFieldValues(userProfile);
                      }}
                    >
                      <CloseOutlined /> Cancel
                    </Button>
                    <Button type="primary" htmlType="submit" className="ms-2">
                      <SaveOutlined /> Save
                    </Button>
                  </Row>
                )}
              </Col>
            </Row>
          </Row>
        </Form>
      </Spin>
    </>
  );
};

export default UserProfile;
